export const NotesFilterConstants = {
    generalNotesFilter: ["ACTIVITY", "FORWARD_TO_PAW", "DISPOSITION", "PAW_STATUS", "RAW_STATUS", "SWIM_NOTE", "WF_STATUS"],
    activityNotesFilter: ["SYSTEM", "ACTIVITY", "FORWARD_TO_PAW", "DISPOSITION", "PAW_STATUS", "RAW_STATUS", "SWIM_NOTE", "WF_STATUS"],
    callGroupNotesFilter: ["SYSTEM", "MANUAL"],
    SYSTEM: "SYSTEM"
}

export const NotesConstants = {
    noteEditStatus: ["EDIT"],
}